import PropTypes from 'prop-types';

export const lastEventShape = {
  message: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  date: PropTypes.string,
  location: PropTypes.string,
  description: PropTypes.string,
};

export function getLastTimelineStatus(timeline) {
  const index = getLastTimelineStatusIndex(timeline);

  if (index >= 0) {
    return timeline[index];
  }

  return null;
}

export function getLastTimelineStatusIndex(timeline) {
  if (timeline.length === 0) {
    return -1;
  }

  const index = timeline.slice().reverse().findIndex(status => status.date);

  if (index >= 0) {
    return timeline.length - 1 - index;
  }

  return -1;
}


// WEBPACK FOOTER //
// ./src/js/widgets/Status/statusHelper.js